import { bool } from 'aws-sdk/clients/signer'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackFaveNumbersChangeTab = (activeTab: string) =>
  trackEvent(keys.faveNumbersEvent, {
    interaction_type: 'Tab Change',
    activeTab,
  })

export const trackFaveNumbersSelectGame = (activeTab: string) =>
  trackEvent(keys.faveNumbersEvent, {
    interaction_type: 'Game Select',
    activeTab,
  })

export const trackFaveNumbersSaveNumbers = () =>
  trackEvent(keys.faveNumbersEvent, {
    interaction_type: 'Save Numbers',
  })

export const trackFaveNumbersDeleteNumbers = () =>
  trackEvent(keys.faveNumbersEvent, {
    interaction_type: 'Delete Numbers',
  })

export const trackFaveNumbersUsedSavedNumbers = (isActivating: bool) =>
  trackEvent(keys.faveNumbersEvent, {
    interaction_type: `Use Saved Numbers ${isActivating ? '(selected)' : '(deselected)'}`,
  })

export const trackFaveNumbersShowPools = () =>
  trackEvent(keys.faveNumbersEvent, {
    interaction_type: 'Show All Pools',
  })
